module.exports = __webpack_public_path__ + "static/media/arrow-right-up.560f1763.svg";